/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDraftArticleRequest } from '../../models/create-draft-article-request';
import { DraftArticleBase } from '../../models/draft-article-base';

export interface CreateDraftArticle$Params {
      body: CreateDraftArticleRequest
}

export function createDraftArticle(http: HttpClient, rootUrl: string, params: CreateDraftArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<DraftArticleBase>> {
  const rb = new RequestBuilder(rootUrl, createDraftArticle.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DraftArticleBase>;
    })
  );
}

createDraftArticle.PATH = '/v0/draft-articles';
